import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { Observable } from "rxjs";
import { inject } from "@angular/core";
import { LoginHelper } from "../helpers/login.helper";

export const AuthGuard: CanActivateFn = (next: ActivatedRouteSnapshot):
  Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {

    let loginHelper = inject(LoginHelper)
    let router = inject(Router)

    const isLoggedIn = loginHelper.get() !== null;


    if (!isLoggedIn) {
      router.navigate(['/login']);
    }

    return isLoggedIn;
  }
